"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupParagraphs = exports.computeDiff = exports.preprocessHtml = exports.diffColors = exports.DIFF_INSERT = exports.DIFF_EQUAL = exports.DIFF_DELETE = void 0;
var diff_match_patch_1 = require("diff-match-patch");
var text_1 = require("./text");
var diff_match_patch_2 = require("diff-match-patch");
Object.defineProperty(exports, "DIFF_DELETE", { enumerable: true, get: function () { return diff_match_patch_2.DIFF_DELETE; } });
Object.defineProperty(exports, "DIFF_EQUAL", { enumerable: true, get: function () { return diff_match_patch_2.DIFF_EQUAL; } });
Object.defineProperty(exports, "DIFF_INSERT", { enumerable: true, get: function () { return diff_match_patch_2.DIFF_INSERT; } });
exports.diffColors = {
    deleteBg: '#F6C6C8',
    deleteText: '#A90D05',
    insertBg: '#C6FADD',
    insertText: '#5B7B6D',
};
var NEW_LINE = "\n";
var preprocessHtml = function (texteHtml) {
    return (0, text_1.stripHtmlTags)(texteHtml.replace(/<\/p>/g, NEW_LINE).replace(/<br\s?\/?>/g, NEW_LINE)).trim();
};
exports.preprocessHtml = preprocessHtml;
var computeDiff = function (before, after) {
    // eslint-disable-next-line new-cap
    var dmp = new diff_match_patch_1.diff_match_patch();
    var diffs = dmp.diff_main(before, after);
    dmp.diff_cleanupSemantic(diffs);
    return diffs;
};
exports.computeDiff = computeDiff;
/**
 * Given an array of diffs; group them by paragraphs and
 * return an array of paragraph-diffs
 */
var groupParagraphs = function (diffs) {
    var e_1, _a;
    var paragraphsDiffs = [];
    var currentParagraph = [];
    try {
        for (var diffs_1 = __values(diffs), diffs_1_1 = diffs_1.next(); !diffs_1_1.done; diffs_1_1 = diffs_1.next()) {
            var diff = diffs_1_1.value;
            var _b = __read(diff, 2), diffMode = _b[0], text = _b[1];
            var chunks = text.split(/\n+/g);
            if (chunks.length === 1) {
                currentParagraph.push(diff);
            }
            else {
                for (var i = 1; i < chunks.length; i++) {
                    currentParagraph.push([diffMode, chunks[i - 1]]);
                    paragraphsDiffs.push(currentParagraph);
                    currentParagraph = i === chunks.length - 1 ? [[diffMode, chunks[i]]] : [];
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (diffs_1_1 && !diffs_1_1.done && (_a = diffs_1.return)) _a.call(diffs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (currentParagraph.length)
        paragraphsDiffs.push(currentParagraph);
    return paragraphsDiffs;
};
exports.groupParagraphs = groupParagraphs;
//# sourceMappingURL=diff.js.map